"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Folders;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var _stringUtils = require("FileManagerCore/utils/stringUtils");

var defaultState = _immutable.default.Map({
  objects: new _immutable.default.List(),
  total: 0,
  status: _Constants.RequestStatus.UNINITIALIZED
});

function getPathMatcher(folder) {
  return new RegExp("^" + (0, _stringUtils.escapeRegExp)(folder.get('full_path')) + "\\/");
}

function findIndex(state, folderId) {
  return state.get('objects').findIndex(function (item) {
    return item.get('id') === folderId;
  });
}

function replaceFolder(state, folder) {
  var index = findIndex(state, folder.get('id'));
  return state.setIn(['objects', index], folder);
}

function deleteFolder(state, folder) {
  var index = findIndex(state, folder.get('id'));
  return state.merge({
    total: state.get('total') - 1,
    objects: state.get('objects').delete(index)
  });
}

function deleteAll(state, folders) {
  return folders.reduce(deleteFolder, state);
}

function move(state, folders, destination) {
  return folders.reduce(function (nextState, folder) {
    var updatedFolder = folder.merge({
      full_path: destination.get('full_path') + "/" + folder.get('name'),
      parent_folder_id: destination.get('id'),
      updated: Date.now()
    });
    return nextState.setIn(['objects', findIndex(nextState, folder.get('id'))], updatedFolder);
  }, state);
}

function handleMove(state, folders, updatedFolders) {
  var toRemove = folders.filter(function (folder) {
    return updatedFolders.findIndex(function (updatedFolder) {
      return updatedFolder.get('id') === folder.get('id');
    }) === -1;
  });
  var nextState = updatedFolders.reduce(replaceFolder, state);
  return deleteAll(nextState, toRemove);
}

function rename(state, updatedFolder) {
  var index = findIndex(state, updatedFolder.get('id'));
  var prevFolder = state.getIn(['objects', index]);
  var pathMatcher = getPathMatcher(prevFolder);
  var escapedPath = updatedFolder.get('full_path').replace(/\$/, '$$$');
  var nextFolders = state.get('objects').map(function (folder) {
    var path = folder.get('full_path');

    if (folder.get('id') === updatedFolder.get('id')) {
      return updatedFolder;
    } else if (pathMatcher.test(path)) {
      var nextPath = path.replace(pathMatcher, escapedPath + "/");
      return folder.set('full_path', nextPath);
    }

    return folder;
  });
  return state.set('objects', nextFolders);
}

function addAll(state, folders) {
  if (folders.count() === 0) {
    return state;
  }

  return state.merge({
    objects: state.get('objects').concat(folders),
    total: state.get('total') + folders.count()
  });
}

function Folders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      status = action.status,
      data = action.data,
      folder = action.folder,
      folders = action.folders,
      updatedFolders = action.updatedFolders,
      destination = action.destination;

  switch (type) {
    case _ActionTypes.default.ADD_FOLDER_SUCCEEDED:
      return state.merge({
        objects: state.get('objects').insert(0, folder).sort(function (folder1, folder2) {
          return folder1.get('name').localeCompare(folder2.get('name'));
        }),
        total: state.get('total') + 1
      });

    case _ActionTypes.default.FETCH_FOLDERS_ATTEMPTED:
    case _ActionTypes.default.FETCH_FOLDERS_FAILED:
      return _immutable.default.Map({
        objects: new _immutable.default.List(),
        total: 0,
        timestamp: null,
        status: status
      });

    case _ActionTypes.default.FETCH_FOLDERS_SUCCEEDED:
      // TODO: update only changed folders
      return _immutable.default.Map({
        objects: data.get('objects'),
        total: data.get('total_count') || data.get('objects').count(),
        timestamp: new Date().getTime(),
        status: status
      });

    case _ActionTypes.default.DELETE_FOLDER_SUCCEEDED:
      return deleteFolder(state, folder);

    case _ActionTypes.default.RENAME_FOLDER_SUCCEEDED:
      return rename(state, folder);

    case _ActionTypes.default.MOVE_FOLDER_SUCCEEDED:
      return replaceFolder(state, folder);

    case _ActionTypes.default.BULK_DELETE_ATTEMPTED:
      return deleteAll(state, folders);

    case _ActionTypes.default.BULK_MOVE_ATTEMPTED:
      return move(state, folders, destination);

    case _ActionTypes.default.BULK_MOVE_SUCCEEDED:
      return handleMove(state, folders, updatedFolders);

    case _ActionTypes.default.BULK_MOVE_FAILED:
    case _ActionTypes.default.BULK_DELETE_FAILED:
      return addAll(state, folders);

    default:
      return state;
  }
}

module.exports = exports.default;